import React, { useEffect, useState, useContext, useRef } from 'react';
import { where } from "firebase/firestore";
import { useParams } from 'react-router-dom';
import { FilterContext } from '../../../shared/context/FilterContext';
import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import { 
    DOCUMENT_PRODUCT, 
    DOCUMENT_COVER,
    DOCUMENT_SECTION_DETAIL,
    LISTENER_PRODUCTS
} from '../../../shared/types/firestoreType';

import Filters from './Filters/Index';
import Products from './Products/Index';
import global from '../../../shared/utility/global';
import storageManager from '../../../shared/utility/storageManager';

import './styles.css';

export default function Index(props) {
    const params = useParams();
    const filterRef = useRef();
    const productFirestore = new CommonCloudFirestore(DOCUMENT_PRODUCT);
    const coverFirestore = new CommonCloudFirestore(DOCUMENT_COVER);
    const sectionDetailFirestore = new CommonCloudFirestore(DOCUMENT_SECTION_DETAIL);

    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [productLoading, setProductLoading] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const filterContext = useContext(FilterContext);

    useEffect(() => {
        if (!firstLoad) {
            onLoadProducts();
        }
    }, [filterContext.inputFilter]);

    useEffect(() => {
        setFirstLoad(false);

        if (params.coverId !== undefined)
            onLoadProductsFromCover(params.coverId);
        else if (params.sectionId !== undefined)
            onLoadProductsFromSection(params.sectionId);
        else if (params.categoryId !== undefined)
            onLoadProductsFromCategory(params.categoryId);
        else {
            onLoadProducts();
            filterRef.current.onLoadCategories();
        }
    }, []);

    const onLoadProductsFromCover = async (coverId) => {
        setProductLoading(true);
        var cover = await coverFirestore.getDocumentById(coverId);
        var _products = await onLoadProducts({ productIds: cover.productIds });
        filterRef.current.onLoadCategories(_products, cover.productIds);
        setProductLoading(false);
    };

    const onLoadProductsFromCategory = async (categoryId) => {
        setProductLoading(true);
        var _products = await onLoadProducts({ categoryId });
        filterRef.current.onLoadCategories(_products, _products.map(m => m.id));
        setProductLoading(false);
    };

    const onLoadProductsFromSection = async (sectionId) => {
        setProductLoading(true);
        var sectionDetail = await sectionDetailFirestore.getDocumentById(sectionId);
        var _products = await onLoadProducts({ productIds: sectionDetail.productIds });
        filterRef.current.onLoadCategories(_products, sectionDetail.productIds);
        setProductLoading(false);
    };

    const onLoadProducts = async (filter) => {
        setProductLoading(true);
        const condition = where("visible", "==", true);
        var documents = await storageManager.fetch(LISTENER_PRODUCTS, async () => await productFirestore.getDocuments(condition));
        setProductLoading(false);

        if (filter?.productIds !== undefined)
            documents = documents.filter(m => filter?.productIds.includes(m.id));

        if (filter?.categoryId !== undefined)
            documents = documents.filter(m => m.categories.includes(filter?.categoryId));

        documents.forEach(item => {
            if (item.price <= 1000)
                item.priceRange = 2;
            else if (item.price >= 1000 && item.price <= 2000)
                item.priceRange = 3;
            else if (item.price >= 2000)
                item.priceRange = 4;
        });

        documents = documents.sort(global.orderBy('name'));

        setProducts(documents);
        setFilteredProducts(documents);
        onSearch(documents);
        return documents;
    };

    const onSearch = (_products) => {
        var values = filterRef.current.getValues();
        _products = _products !== undefined && typeof _products !== 'string' ? (_products.length === undefined ? products : _products) : products;
        const filtered = _products.filter(item =>
            (filterContext.inputFilter === '' || global.formatSearch(item.name).match(global.formatSearch(filterContext.inputFilter))) &&
            (
                values.priceRange === 1 ||
                item.priceRange === values.priceRange ||
                (values.priceRange === 5 && ((values.minPrice === undefined && values.maxPrice === undefined) ||
                    (item.price >= values.minPrice && values.maxPrice === undefined) ||
                    (values.minPrice === undefined && item.price <= values.maxPrice) ||
                    (item.price >= values.minPrice && item.price <= values.maxPrice)))
            ) &&
            (!values.freeShipping || item.freeShipping === values.freeShipping) &&
            (values.categoryIds.length === 0 || item.categories.filter(m => values.categoryIds.includes(m)).length > 0)
        );

        setFilteredProducts(filtered);
    };

    return (
        <div id="components-feature-product">
            <div className="title-product">
                Catálogo de Productos
            </div>
            <div className='container'>
                <div style={{ marginTop: '20px' }}>
                    <div className='row justify-content-center pb-2 g-3'>
                        <div className="col-12 col-md-3 fixed-column">
                            <Filters
                                ref={filterRef}
                                onSearch={onSearch}
                            />
                        </div>
                        <div className="col-12 col-md">
                            <Products
                                products={filteredProducts}
                                loading={productLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}